import React, { useEffect, useRef, useState } from "react";
import "./Insurance.css";
import Testimonial from "../../../Testimonial/Testimonial";
import { Helmet } from "react-helmet";

const Insurance = () => {
  const techItemsRow1 = [
    { name: "Angular.js", logo: "/logos/angular.png" },
    { name: "HTML", logo: "/logos/html.png" },
    { name: "CSS3", logo: "/logos/css.png" },
    { name: "Bootstrap", logo: "/logos/bootstrap.png" },
    { name: "Javascript", logo: "/logos/javascript.png" },
    { name: "AmazonDB", logo: "/logos/amazon_dynamodb.png" },
    { name: "Appian", logo: "/logos/appian.png" },
    { name: "Laravel", logo: "/logos/laravel.png" },
    { name: "MariaDB", logo: "/logos/mariadb.png" },
    { name: "MongoDB", logo: "/logos/mongodb.png" },
    { name: "Android", logo: "/logos/android-5.png" },
    { name: "ERC-20", logo: "/logos/erc-20.png" },
    { name: "Ethereum", logo: "/logos/ethereum.png" },
    { name: "Flutter", logo: "/logos/flutter.png" },
    { name: "Ionic", logo: "/logos/ionic.png" },
    {
      name: "Artificial Intelligence",
      logo: "/logos/artificial-intelligence.png",
    },
    { name: "Augmented Reality", logo: "/logos/Augmented Reality.png" },
    { name: "Crda", logo: "/logos/crda.png" },
    { name: "Data Science", logo: "/logos/data-science.png" },
    { name: "Go Chain", logo: "/logos/gochain.png" },
  ];

  const techItemsRow2 = [
    { name: "Sass", logo: "/logos/saas.png" },
    { name: "JQuery", logo: "/logos/jquery.png" },
    { name: "Less", logo: "/logos/less.png" },
    { name: "Codeigniter", logo: "/logos/codeignitor.png" },
    { name: "Django", logo: "/logos/django.png" },
    { name: "Node JS", logo: "/logos/node js.png" },
    { name: "PHP", logo: "/logos/php.png" },
    { name: "Salesforce", logo: "/logos/salesforce.png" },
    { name: "SQL Server", logo: "/logos/sql-server.png" },
    { name: "MySQL", logo: "/logos/mysql-5.png" },
    { name: "IOS", logo: "/logos/ios.png" },
    { name: "Oracle 6", logo: "/logos/oracle.png" },
    { name: "PostgreSQL", logo: "/logos/postgresql.png" },
    { name: "React Native", logo: "/logos/react_native.png" },
    { name: "Solidity", logo: "/logos/Solidity.png" },
    { name: "Hyperledger", logo: "/logos/Hyperledger.png" },
    { name: "Internet Of Things", logo: "/logos/iot.png" },
    { name: "One Ledger", logo: "/logos/OneLedger.png" },
    { name: "Virtual Reality", logo: "/logos/virtual-reality.png" },
  ];

  const duplicatedRow1 = [...techItemsRow1, ...techItemsRow1];
  const duplicatedRow2 = [...techItemsRow2, ...techItemsRow2];

  const containerRef = useRef(null);
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offset, setOffset] = useState(0);
  const animationRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollSpeed = 1;

    const animate = () => {
      setOffset((prevOffset) => {
        const maxOffset = row1Ref.current?.scrollWidth / 2 || 0;
        const newOffset = prevOffset + scrollSpeed;
        return newOffset >= maxOffset ? 0 : newOffset;
      });
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
    };
  }, [containerWidth]);

  const [showModal, setShowModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const consultationOptions = [
    {
      id: 1,
      title: "Insurance Policy Management",
      description:
        "Comprehensive digital systems for managing insurance policies and customer data",
      whatsappMessage:
        "Hello, I'm interested in Insurance Policy Management consultation.",
    },
    {
      id: 2,
      title: "Claims Processing Automation",
      description:
        "AI-powered solutions for streamlining and automating insurance claims processing",
      whatsappMessage:
        "Hello, I'm interested in Claims Processing Automation consultation.",
    },
    {
      id: 3,
      title: "Risk Assessment Analytics",
      description:
        "Data-driven insights for risk evaluation, pricing, and underwriting decisions",
      whatsappMessage:
        "Hello, I'm interested in Risk Assessment Analytics consultation.",
    },
    {
      id: 4,
      title: "Customer Portal Solutions",
      description:
        "Digital platforms for customer self-service and policy management",
      whatsappMessage:
        "Hello, I'm interested in Customer Portal Solutions consultation.",
    },
    {
      id: 5,
      title: "Insurance CRM Systems",
      description:
        "Customer relationship management tailored for insurance providers",
      whatsappMessage:
        "Hello, I'm interested in Insurance CRM Systems consultation.",
    },
    {
      id: 6,
      title: "Fraud Detection Technology",
      description:
        "AI and machine learning solutions for detecting insurance fraud",
      whatsappMessage:
        "Hello, I'm interested in Fraud Detection Technology consultation.",
    },
  ];

  const handleButtonClick = () => {
    setShowModal(true);
    setSelectedOption(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleWhatsAppRedirect = () => {
    if (selectedOption) {
      const message = encodeURIComponent(selectedOption.whatsappMessage);
      window.open(`https://wa.me/+919155599968?text=${message}`, "_blank");
      setShowModal(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  return (
    <div className="insurance-sector-page">
      <Helmet>
        <title>
          Insurance Sector Technology Solutions | Innovative Insurance Industry
          Services
        </title>
        <meta
          name="description"
          content="Explore our comprehensive insurance technology solutions including policy management systems, claims processing automation, risk assessment analytics, and customer portal solutions."
        />
        <meta
          name="keywords"
          content="insurance technology, insurtech, policy management, claims processing, risk assessment, insurance CRM, fraud detection, insurance solutions, insurance innovation, insurance apps, insurance data, insurance sector SaaS, insurance industry management, insurance digital transformation"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="insurance-sector-hero">
        <div className="insurance-sector-hero-content">
          <h1 className="insurance-sector-hero-title">
            Transforming{" "}
            <span className="insurance-sector-highlight">
              The Insurance Industry
            </span>
          </h1>
          <p className="insurance-sector-hero-description">
            We deliver cutting-edge insurance technology solutions that
            streamline operations, enhance customer experience, and drive
            growth. From policy management to claims automation and AI-powered
            risk assessment.
          </p>
          <div className="insurance-sector-hero-buttons">
            <a href="/contact-us">
              <button className="insurance-sector-btn insurance-sector-btn-primary">
                Get Started
              </button>
            </a>
            <button className="insurance-sector-btn insurance-sector-btn-secondary">
              Learn More
            </button>
          </div>
        </div>
        <div className="insurance-sector-hero-visual">
          <div className="insurance-sector-animated-shield">
            <div className="insurance-sector-shield-core"></div>
            <div className="insurance-sector-protection-layer"></div>
            <div className="insurance-sector-data-points"></div>
          </div>
          <div className="insurance-sector-orb insurance-sector-orb-1"></div>
          <div className="insurance-sector-orb insurance-sector-orb-2"></div>
          <div className="insurance-sector-orb insurance-sector-orb-3"></div>
        </div>
      </section>

      {/* Services Section */}
      <section className="insurance-sector-services">
        <div className="insurance-sector-services-header">
          <h2 className="insurance-sector-section-title">
            Our Insurance Technology Solutions
          </h2>
          <p className="insurance-sector-section-subtitle">
            Innovative insurance technology services designed to modernize the
            insurance industry, enhance operational efficiency, and improve
            customer satisfaction.
          </p>
        </div>

        <div className="insurance-sector-services-grid">
          {/* Policy Management Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-policy"></div>
            </div>
            <h3>Policy Management Systems</h3>
            <p>
              Comprehensive digital platforms for managing insurance policies,
              renewals, and customer data.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Underwriting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Renewals</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Document Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Efficiency Gain</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">99.5%</div>
                <div className="stat-label">Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Claims Processing Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-claims"></div>
            </div>
            <h3>Claims Processing Automation</h3>
            <p>
              AI-powered solutions for streamlining and automating insurance
              claims processing.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Assessment</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Digital Documentation</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Status Tracking</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">60%</div>
                <div className="stat-label">Faster Processing</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">85%</div>
                <div className="stat-label">Customer Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Risk Assessment Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-risk"></div>
            </div>
            <h3>Risk Assessment Analytics</h3>
            <p>
              Data-driven insights for risk evaluation, pricing, and
              underwriting decisions.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Predictive Modeling</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Data Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Custom Risk Scores</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Market Trends</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Better Decisions</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Faster Analysis</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Customer Portal Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-portal"></div>
            </div>
            <h3>Customer Portal Solutions</h3>
            <p>
              Digital platforms for customer self-service, policy management,
              and claims tracking.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Policy Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Claims Submission</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Payment Processing</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Document Access</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">45%</div>
                <div className="stat-label">Service Cost Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">90%</div>
                <div className="stat-label">Customer Satisfaction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Insurance CRM Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-crm"></div>
            </div>
            <h3>Insurance CRM Systems</h3>
            <p>
              Customer relationship management tailored for insurance providers
              and agents.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Lead Management</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Policy Tracking</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Communication Tools</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Sales Analytics</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">30%</div>
                <div className="stat-label">Sales Increase</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">75%</div>
                <div className="stat-label">Agent Productivity</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Fraud Detection Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-fraud"></div>
            </div>
            <h3>Fraud Detection Technology</h3>
            <p>
              AI and machine learning solutions for detecting and preventing
              insurance fraud.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Pattern Recognition</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Anomaly Detection</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Alerts</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">70%</div>
                <div className="stat-label">Fraud Detection Rate</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">25%</div>
                <div className="stat-label">Cost Reduction</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Telematics Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-telematics"></div>
            </div>
            <h3>Telematics & IoT Solutions</h3>
            <p>
              Usage-based insurance solutions leveraging telematics and IoT
              devices.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Real-time Monitoring</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Behavior Analysis</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Custom Premiums</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Driver Feedback</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">40%</div>
                <div className="stat-label">Accident Reduction</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">35%</div>
                <div className="stat-label">Premium Accuracy</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>

          {/* Compliance Card */}
          <div className="insurance-sector-service-card">
            <div className="insurance-sector-service-icon">
              <div className="insurance-sector-icon insurance-sector-icon-compliance"></div>
            </div>
            <h3>Regulatory Compliance Tools</h3>
            <p>
              Solutions to ensure compliance with insurance regulations and
              reporting requirements.
            </p>

            <div className="service-features">
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Automated Reporting</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Audit Trails</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Regulation Updates</span>
              </div>
              <div className="service-feature">
                <span className="feature-icon">✓</span>
                <span>Compliance Monitoring</span>
              </div>
            </div>

            <div className="service-stats">
              <div className="service-stat">
                <div className="stat-number">50%</div>
                <div className="stat-label">Time Saved</div>
              </div>
              <div className="service-stat">
                <div className="stat-number">100%</div>
                <div className="stat-label">Compliance Rate</div>
              </div>
            </div>

            <button className="service-cta-btn">Explore Solutions</button>
          </div>
        </div>

        <div className="insurance-sector-services-cta">
          <h3>Ready to transform your insurance business?</h3>
          <p>
            Schedule a free consultation with our insurance technology experts
            to discuss your specific needs.
          </p>
          <div className="services-cta-buttons">
            <div className="insurance-sector-consultation-container">
              <button
                className="insurance-sector-primary-btn insurance-sector-pulse"
                onClick={handleButtonClick}
              >
                Book a Consultation
              </button>

              {showModal && (
                <div className="insurance-sector-modal-overlay">
                  <div className="insurance-sector-modal-content">
                    <button
                      className="insurance-sector-close-btn"
                      onClick={handleCloseModal}
                    >
                      &times;
                    </button>

                    <h2 className="insurance-sector-modal-title">
                      Insurance Technology Consultation
                    </h2>
                    <p className="insurance-sector-modal-subtitle">
                      Select an area you need consultation on:
                    </p>

                    <div className="insurance-sector-options-grid">
                      {consultationOptions.map((option) => (
                        <div
                          key={option.id}
                          className={`insurance-sector-option-card ${
                            selectedOption?.id === option.id ? "selected" : ""
                          }`}
                          onClick={() => handleOptionSelect(option)}
                        >
                          <h3 className="insurance-sector-option-title">
                            {option.title}
                          </h3>
                          <p className="insurance-sector-option-desc">
                            {option.description}
                          </p>
                        </div>
                      ))}
                    </div>

                    <button
                      className={`insurance-sector-whatsapp-btn ${
                        selectedOption ? "active" : ""
                      }`}
                      onClick={handleWhatsAppRedirect}
                      disabled={!selectedOption}
                    >
                      Continue to WhatsApp
                    </button>
                  </div>
                </div>
              )}
            </div>
            <button className="insurance-sector-btn insurance-sector-btn-secondary">
              View Case Studies
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="insurance-sector-stats">
        <div className="insurance-sector-stats-container">
          <div className="insurance-sector-stat">
            <h3 className="insurance-sector-stat-number" data-count="200">
              200
            </h3>
            <p className="insurance-sector-stat-label">Insurance Projects</p>
          </div>
          <div className="insurance-sector-stat">
            <h3 className="insurance-sector-stat-number" data-count="97">
              168
            </h3>
            <p className="insurance-sector-stat-label">Client Satisfaction</p>
          </div>
          <div className="insurance-sector-stat">
            <h3 className="insurance-sector-stat-number" data-count="15">
              11
            </h3>
            <p className="insurance-sector-stat-label">Years Experience</p>
          </div>
          <div className="insurance-sector-stat">
            <h3 className="insurance-sector-stat-number" data-count="35">
              35
            </h3>
            <p className="insurance-sector-stat-label">Countries Served</p>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <div className="tech-slider-container" ref={containerRef}>
        <h2 className="tech-slider-title">Tools & Tech Stack</h2>
        <div className="tech-slider-divider"></div>

        {/* First row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row1Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow1.map((tech, index) => (
              <div key={`row1-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row */}
        <div className="tech-slider-wrapper">
          <div
            className="tech-slider-row"
            ref={row2Ref}
            style={{ transform: `translateX(-${offset}px)` }}
          >
            {duplicatedRow2.map((tech, index) => (
              <div key={`row2-${index}`} className="tech-slide">
                <img
                  src={tech.logo}
                  alt={tech.name}
                  className="tech-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/logos/default.png";
                  }}
                />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="insurance-sector-cta">
        <div className="insurance-sector-cta-content">
          <h2>Ready to Transform Your Insurance Business?</h2>
          <p>
            Contact us today to discuss how our insurance technology expertise
            can help your organization innovate and improve operational
            efficiency.
          </p>
          <a href="/contact-us">
            <button className="insurance-sector-btn insurance-sector-btn-primary insurance-sector-btn-large">
              Schedule a Consultation
            </button>
          </a>
        </div>
      </section>

      <Testimonial />
    </div>
  );
};

export default Insurance;
